const host = window.location.hostname;
const configs: any = {
  localhost: {
    api: "http://localhost:5001",
    name: "development",
    cookiesDomain: "localhost",
  },
  "auth.staging.gorillascode.com": {
    api: "https://api.auth.staging.gorillascode.com",
    name: "staging",
    cookiesDomain: "auth.staging.gorillascode.com",
  },
  "auth.quiteja.com.br": {
    api: "https://api.auth.quiteja.com.br",
    name: "production",
    cookiesDomain: "auth.quiteja.com.br",
  },
};

if (!configs[host]) {
  configs[host] = {
    api: `http://${host}:5001`,
    name: "development",
    cookiesDomain: "localhost",
  };
}

let env = configs[host];

if (host.includes("pr-")) {
  env = configs["auth.staging.gorillascode.com"];
}

export default env;
